import React, { Component } from 'react';
import { get } from 'lodash';
import { Expand, getParent } from '@sabre/aven-spark';
import { connect } from 'react-redux';
import { ControlledSelect as Select } from '../../../../components/ui/sabre-spark-react-ex';
import { onThemePropChange } from '../../../helpers/ThemeStoreHelpers';
import { checkPermissions } from '../../../../../lib/utils';
import { Service as FileService } from '../../../../services/Service';
import { CATEGORIES } from '../../../../services/fileUpload/uploadFile';
import { CodeEditorPanel } from '../../../widgets/CodeEditor/CodeEditorPanel';
import { CodeEditorPanelSectionToolbar } from '../../../widgets/CodeEditor/CodeEditorPanelSectionToolbar';
import { SAVE_LEVEL } from '../../../../constants/Level';
import { CHANGE_CUSTOM_CONTENT_LANGUAGE_CODE, SET_TEXT_VALUE_IN_CONFIG } from '../../../../constants/ActionTypes';
import './custom-content.scss';
import { ACCESS_POINTS_GROUP } from '../../../../constants/AccessPoints';

const prefix = 'customContent';

const pages = {
    hotels: {
        label: 'Hotels'
    },
    products: {
        label: 'Rooms'
    },
    addOns: {
        label: 'Addons'
    },
    cart: {
        label: 'Cart'
    },
    checkout: {
        label: 'Checkout'
    },
    review: {
        label: 'Review'
    },
    confirm: {
        label: 'Confirm'
    },
    signin: {
        label: 'Sign in'
    },
    'search-results': {
        label: 'Search results'
    },
    'sign-up': {
        label: 'Sign up'
    },
    profile: {
        label: 'Profile'
    },
    'reservation-list': {
        label: 'Reservation List'
    },
    landing: {
        label: 'Landing'
    },
    reset: {
        label: 'Reset'
    },
    'retail-product-list': {
        label: 'Retail Product List'
    },
    'retail-product-details': {
        label: 'Retail Product Details'
    }
};

const categories = {
    head: {
        label: 'Head',
        global: true
    },
    globalTop: {
        label: 'Global Top',
        global: true
    },
    globalHeader: {
        label: 'Global Header',
        global: true
    },
    globalBottom: {
        label: 'Global Bottom',
        global: true
    },
    top: {
        label: 'Top',
        sections: pages,
        global: false
    },
    header: {
        label: 'Header',
        sections: pages,
        global: false
    },
    bottom: {
        label: 'Bottom',
        sections: pages,
        global: false
    }
};

const noop = () => {};
function onAssetSelected(section, asset) {
    const { languageCode } = this.props;

    this.props.onThemePropChange(`customContent.${languageCode}.${section}`)(
        FileService.assetUrl(
            asset.chainid,
            asset.hotelid,
            null,
            asset.hotelid ? SAVE_LEVEL.HOTEL : SAVE_LEVEL.CHAIN,
            asset.filename,
            true,
            asset.category
        )
    );
    this.setState({
        onAssetSelected: noop
    });
}
class CustomContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            focused: null,
            file: '',
            currentlyEdited: '',
            categoryRef: null,
            onAssetSelected: noop,
            loading: {}
        };
    }
    componentWillReceiveProps(nextProps) {
        const { customContent } = this.props;
        if (this.props.languageCode !== nextProps.languageCode) {
            this.setState({
                file: this.state.currentlyEdited
                    ? get(customContent, `${nextProps.languageCode}.${this.state.currentlyEdited}`, '')
                    : ''
            });
        }
    }
    renderCategory(categoryLabel, categoryKey) {
        const { customContent, languageCode } = this.props;
        const value = get(customContent, `${languageCode}.${categoryKey}`, '');

        return (
            <div
                className={`spark-panel ${categories[categoryKey].sections ? 'spark-panel--expand' : ''} spark-mar-b-1`}
                key={`category-${categoryKey}`}
            >
                <div
                    className="spark-panel__header"
                    role="heading"
                    tabIndex="0"
                    aria-expanded="false"
                    aria-controls={`${categoryKey}-sections`}
                    ref={node => (categories[categoryKey].ref = node)}
                >
                    <CodeEditorPanelSectionToolbar
                        permission={this.props.hasAccess}
                        renderButtons={categories[categoryKey].global}
                        label={categoryLabel}
                        file={value}
                        path={categoryKey}
                        loading={this.state.loading[categoryKey]}
                        onSelect={() => {
                            this.setState(
                                {
                                    onAssetSelected: onAssetSelected.bind(this, categoryKey)
                                },
                                () => {
                                    this.editorPanelRef.getWrappedInstance().openAssetBrowser();
                                }
                            );
                        }}
                        onEdit={() => {
                            this.setState({
                                file: value,
                                currentlyEdited: categoryKey,
                                categoryRef: categories[categoryKey].ref
                            });
                        }}
                        onClear={() => {
                            this.props.onThemePropChange(`customContent.${this.props.languageCode}.${categoryKey}`)('');
                        }}
                    >
                        <div>{value instanceof Object ? '' : value}</div>
                    </CodeEditorPanelSectionToolbar>
                </div>
                {categories[categoryKey].sections && (
                    <div
                        id={`${categoryKey}-sections`}
                        aria-hidden="true"
                        className="spark-panel__content custom-content__categories"
                    >
                        {Object.entries(categories[categoryKey].sections).map(([sectionKey, section]) =>
                            this.renderSection(`${categoryKey}.${sectionKey}`)
                        )}
                    </div>
                )}
            </div>
        );
    }
    renderSection(sectionPath) {
        const { customContent, languageCode } = this.props;
        const value = get(customContent, `${languageCode}.${sectionPath}`, '');
        const category = sectionPath.split('.')[0];
        const section = get(categories, `${sectionPath.split('.').join('.sections.')}`);
        const label = section.label;

        return (
            <section key={sectionPath}>
                <CodeEditorPanelSectionToolbar
                    permission={this.props.hasAccess}
                    renderButtons={true}
                    label={label}
                    file={value}
                    path={sectionPath}
                    loading={_.get(this.state, `loading[${sectionPath}]`, false)}
                    onSelect={() => {
                        this.setState(
                            {
                                onAssetSelected: onAssetSelected.bind(this, sectionPath)
                            },
                            () => {
                                this.editorPanelRef.getWrappedInstance().openAssetBrowser();
                            }
                        );
                    }}
                    onEdit={() => {
                        this.setState({
                            file: value,
                            currentlyEdited: sectionPath,
                            categoryRef: categories[category].ref
                        });
                    }}
                    onClear={() => {
                        this.props.onThemePropChange(`customContent.${this.props.languageCode}.${sectionPath}`)('');
                    }}
                >
                    <div>{value instanceof Object ? '' : value}</div>
                </CodeEditorPanelSectionToolbar>
            </section>
        );
    }
    componentDidMount() {
        const _onClick = function(e) {
            if (e.target.classList.contains('spark-toolbar__item-helper')) {
                return;
            }
            return this._onClickBoundOriginal(e);
        };
        this._categoriesExpandableInstances = Array.from(this.categoriesRef.children).map(el => {
            const instance = new Expand(el);
            instance.el.removeEventListener('click', instance._onClickBound);
            instance._onClickBoundOriginal = instance._onClickBound;
            instance._onClickBound = _onClick.bind(instance);
            instance.el.addEventListener('click', instance._onClickBound);
            return instance;
        });
    }
    componentWillUnmount() {
        this._categoriesExpandableInstances &&
            this._categoriesExpandableInstances.forEach(instance => instance.remove());
    }
    getEditedSectionTitle() {
        const fragments = this.state.currentlyEdited.split('.');
        let title = '';
        if (this.state.currentlyEdited !== '' && fragments.length === 1) {
            title = categories[fragments[0]].label;
        } else if (this.state.currentlyEdited !== '' && fragments.length === 2) {
            title = `${categories[fragments[0]].label}: ${categories[fragments[0]].sections[fragments[1]].label}`;
        }
        return title;
    }
    render() {
        const { languageCode, languageList, permission } = this.props;
        return (
            <div className="ThemeColors Theme-Content">
                <h1>Custom Content</h1>
                <div className="subpages-main-content">
                    <div className="spark-panel spark-margin-top">
                        <div className="spark-panel__content">
                            <div className="row">
                                <div className="col-xs-4">
                                    <Select
                                        className="col-xs-7 spark-mar-b-2"
                                        label="Select a Language"
                                        value={languageCode}
                                        options={languageList.map(language => ({
                                            key: language.code,
                                            label: language.name
                                        }))}
                                        onChange={value => {
                                            this.props.changeCustomContentLanguageCode(value);
                                        }}
                                    />
                                    <div ref={node => (this.categoriesRef = node)} className={'custom-content'}>
                                        {Object.entries(categories).map(([categoryKey, category]) =>
                                            this.renderCategory(category.label, categoryKey)
                                        )}
                                    </div>
                                </div>
                                <div className="col-xs spark-flex">
                                    <CodeEditorPanel
                                        ref={node => (this.editorPanelRef = node)}
                                        permission={this.props.hasAccess}
                                        languageCode={languageCode}
                                        file={this.state.file}
                                        category={CATEGORIES.CUSTOMIZATION}
                                        title={this.getEditedSectionTitle()}
                                        caretTarget={this.state.categoryRef}
                                        editedSection={this.state.currentlyEdited}
                                        onBeforeSave={(saveLanguageCode, section) => {
                                            this.setState({
                                                loading: { ...this.state.loading, [section]: true }
                                            });
                                        }}
                                        onSave={(saveLanguageCode, section, response) => {
                                            const file = get(response.data, 'FilesResult.FilePath', '').replace(
                                                '/opt/',
                                                ''
                                            );
                                            this.props.onThemePropChange(
                                                `customContent.${saveLanguageCode}.${section}`
                                            )(file);
                                            this.setState({
                                                file,
                                                loading: { ...this.state.loading, [section]: false }
                                            });
                                        }}
                                        onCancel={() => {
                                            this.setState({
                                                file: '',
                                                currentlyEdited: '',
                                                categoryRef: null
                                            });
                                        }}
                                        onAssetSelected={this.state.onAssetSelected}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        customContent: state.app.data.theme.customContent.customContent,
        languageCode: state.app.data.configuration.configuration.customContentLanguageCode,
        languageList: state.app.selected.languageList,
        defaultLanguageCode: state.app.selected.defaultCode,
        level: state.app.selected.level,
        hasAccess: checkPermissions(state, ACCESS_POINTS_GROUP.CUSTOM_CONTENT)
    };
};

const mapDispatchToProps = dispatch => ({
    setConfigField: (code, value) => {
        dispatch({ type: SET_TEXT_VALUE_IN_CONFIG, code: code, value: value });
    },
    changeCustomContentLanguageCode: code => {
        dispatch({ type: CHANGE_CUSTOM_CONTENT_LANGUAGE_CODE, languageCode: code });
    },
    onThemePropChange: onThemePropChange(dispatch, prefix)
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomContent);



// WEBPACK FOOTER //
// ./src/components/pages/theme/custom-content/index.js